import React from 'react';

import { MainPageLayout } from 'layouts/MainPageLayout';

import { Profile } from 'components/Profile';

export const Settings: React.FC = () => {
	return (
		<MainPageLayout>
			<Profile />
		</MainPageLayout>
	);
};



